import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path d="M18.308 0L1.438 16.873.002 24l7.125-1.437L23.999 5.688 18.308 0zM2.557 21.444l.723-3.585L15.519 5.618 18.38 8.48 6.141 20.721l-3.584.723zM19.794 7.066l-2.861-2.862 1.377-1.377 2.861 2.861-1.377 1.378z" /></svg>);